import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import PricingSection from './components/PricingSection';
import QuantumExpressionsSection from './components/QuantumExpressionsSection';
import TrustSection from './components/TrustSection';
import CommunityQuestionsSection from './components/CommunityQuestionsSection';
import DisclaimerSection from './components/DisclaimerSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CommunityQuestionsSection />
        <PricingSection />
        <QuantumExpressionsSection />
        <TrustSection />
        <DisclaimerSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;